import { render, staticRenderFns } from "./HowWillPay.vue?vue&type=template&id=afc1481a&scoped=true&"
import script from "./HowWillPay.vue?vue&type=script&lang=js&"
export * from "./HowWillPay.vue?vue&type=script&lang=js&"
import style0 from "./HowWillPay.vue?vue&type=style&index=0&id=afc1481a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc1481a",
  null
  
)

export default component.exports